import { AllergenDto } from './allergen.dto';
import { CustomerLoyaltyDto } from './customer-loyalty.dto';
import { CustomerAddressDto } from './customerAddress.dto';

export class CustomerDetailDto {
  id: number;
  fullName: string;
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber: string;
  phoneAreaCode?: string;
  photoURL: string;
  createdDate?: Date;
  acceptsMarketingTerms?: boolean;
  tags?: string;
  customerAddress?: CustomerAddressDto[];
  totalOrders?: number;
  averageOrderValue?: number;
  lifetimeOrderValue?: number;
  recentOrders?: CustomerDetailRecentOrderDto[];
  topPurchasedProducts?: CustomerDetailTopProductDto[];
  allergens?: AllergenDto[];
  loyalty?: CustomerLoyaltyDto[];
  orderTypes?:CustomerDetailOrderTypeDto[];
}

export class CustomerDetailTopProductDto {
  productName: string;
  quantity: number;
  price: number;
}

export class CustomerDetailOrderTypeDto {
  typeId: number;
  typeName: string;
  count: number;
  totalValue: number;
}

export class CustomerDetailRecentOrderDto {
  orderDate: Date;
  orderValue: number;
}